export const environment = {
  production: true,
  client: 'guinee',
  env: 'uat',
  myanmar: {
    gamesEnable: {
      dge: true,
      sle: true,
      ige: true,
      sge2: true,
      default: 'dge',
    },
    theme: ['midnight-express-theme'],
    domain: 'https://beta-games.bet2winasia.com/api',
    printDomain: 'http://192.168.132.68:3000',
    drawMachine_luckySix: 'https://beta-rms.bet2winasia.com/AndmanLuckySix/web-mobile/',
    drawMachine_superKeno: 'https://beta-rms.bet2winasia.com/AndmanKeno20/web-mobile/',
    drawMachine_lottoDiamond: 'https://beta-rms.bet2winasia.com/AndmanLottoDiamond/web-mobile/',
    ige_socket_url: 'wss://beta-ige.bet2winasia.com/JackpotEngine/socket',
  },
  cameroon: {
    gamesEnable: {
      dge: true,
      sle: true,
      ige: true,
      sge: true,
      sge2: true,
      cap: true,
      default: 'dge',
    },
    theme: ['tropical-rain-forest-theme', 'style-cameroon'],
    domain: 'https://uat-games.camwinlotto.cm/api',
    printDomain: 'http://192.168.132.68:3000',
    // drawMachine_luckySix: 'https://uat-dms.camwinlotto.cm/LuckySix/web-mobile/',
    // drawMachine_superKeno: 'https://uat-dms.camwinlotto.cm/SuperKeno/web-mobile/',
    drawMachine_luckySix: 'https://beta-rms.bet2winasia.com/CameroonLucky6/web-mobile/',
    drawMachine_superKeno: 'https://beta-rms.bet2winasia.com/Cameroon-keno/web-mobile/',
    drawMachine_fiveByNinety: 'https://beta-rms.bet2winasia.com/Cameroon-fivebyninety/web-mobile/',
  },
  kenya: {
    gamesEnable: {
      dge: true,
      ige: true,
      default: 'dge',
    },
    theme: ['midnight-express-theme'],
    domain: 'https://uat-games.sabanzuri.com/api',
    printDomain: 'http://192.168.132.68:3000',
    drawMachine_powerPlay: 'https://uat-dms.sabanzuri.com/LuckyTwelve/web-mobile/',
    drawMachine_powerBall: 'https://uat-dms.sabanzuri.com/Sabanzurilotto/web-mobile/',
  },
  ice: {
    gamesEnable: {
      dge: true,
      sle: true,
      bingo: true,
      ige: true,
      default: 'dge',
    },
    theme: ['cobalt-theme'],
    domain: 'https://games.infinitilotto.com/api',
    printDomain: 'http://192.168.132.68:3000',
    drawMachine_luckySix: 'https://rms-ang.infinitilotto.com/LuckySix/web-mobile/',
    drawMachine_superKeno: 'https://rms-ang.infinitilotto.com/SuperKeno/web-mobile/',
    drawMachine_lottoDiamond: 'https://rms-ang.infinitilotto.com/AndmanLottoDiamond/web-mobile/',
    drawMachine_fiveByNinety: 'https://rms-ang.infinitilotto.com/InfinitiLotto5by90/web-mobile/',
    dge_webSocket_domain: 'wss://rms-ang.infinitilotto.com/drawmachine',
    dge_webSocket_user: 'user',
    dge_webSocket_pswd: 'user',
    chat_socket: 'https://bingo-games.infinitilotto.com:3234',
    ige_socket_url: 'wss://ige.infinitilotto.com/JackpotEngine/socket',
  },
  guinee: {
    gamesEnable: {
      dge: true,
      sle: true,
      bingo: true,
      ige: true,
      default: 'dge',
    },
    theme: ['tropical-rain-forest-theme'],
    domain: 'https://games-uat.guineemillions.net/api',
    // printDomain: 'https://games-dev.winweaver.com',
    printDomain: 'http://192.168.132.68:3000',
    drawMachine_fiveByNinety: 'https://dms-uat.guineemillions.net/DrawMachines/5by90/web-mobile/',
    drawMachine_eightbytwentyfour: 'https://dms-uat.guineemillions.net/DrawMachines/8by24/web-mobile/',
    dge_webSocket_domain: 'wss://dms-uat.guineemillions.net/drawmachine',
    dge_webSocket_user: 'user',
    dge_webSocket_pswd: 'user',
    chat_socket: 'https://bingo-dms-uat.guineemillions.net:3234',
    ige_socket_url: 'wss://dms-uat.guineemillions.net/websocket',
  },
};

